import { API_URL } from "Constant/Environment";

//REGISTER
export const POST_USER_LOGIN = "users/login";
export const FILE_UPLOAD_URL = `${API_URL}/temple/process`;
export const FILE_DOWNLOAD = `${API_URL}/temple/download`;
